module.exports = __webpack_public_path__ + "static/media/hotelios_zakladni_logo.70ca577f.svg";